import {createContext} from "react";

export const DashboardNavigationContext = createContext(null)